import React from "react";
import { useSelector } from "react-redux";
import { fontSize } from "utils/CONSTANTS";
import { convertToRGBAString, renderSmile } from "utils/helperFunctions";
import { Col, Form, Row } from "antd";

//@ts-ignore
const ServiceRow = React.memo(
  ({ data, service, selectedLanguage, onSmileClick }) => {
    const { isRTL, widgetJSON, feedbackArray } = useSelector((state) => state);

    const { error_messages: errorMessages } = widgetJSON.data.general_settings;

    const feedback =
      feedbackArray.find((item) => item.serviceId === service.id) || {};

    const {
      required = false,
      rate_options = [],
      name = {},
      bg_color = [],
      rate_bg_color = [],
      rate_icon_color = [],
      text_color = [],
      rate_selected_color = [],
    } = service || {};
    const { show_rate_labels = false, attrs = {} } = data || {};

    return (
      <Form.Item
        name={service.id}
        className="reset-ant-form"
        rules={[
          {
            required: required,
            message: errorMessages.required[selectedLanguage],
          },
        ]}
      >
        <div
          className="service-row"
          style={{
            backgroundColor: convertToRGBAString(bg_color),
          }}
        >
          <Row
            justify="center"
            className="left-to-right-holder"
            style={{ marginBottom: 20 }}
          >
            <Col
              className="font-helvetica-neue-medium"
              style={{
                fontSize: fontSize[attrs.service_name_size],
                color: convertToRGBAString(text_color),
                textAlign: "center",
              }}
            >
              {name[selectedLanguage]}
            </Col>
          </Row>
          <div
            className={`flex-items-row ${isRTL && "component-right-to-left"}`}
          >
            {rate_options.map((option, index) => {
              return (
                <div
                  key={index}
                  onClick={onSmileClick(service, option)}
                  style={{
                    padding: "5px 0",
                    flex: 1,
                    borderRadius: 8,
                    width: `calc((100% - ${
                      (rate_options.length - 1) * 8
                    }px) / ${rate_options.length})`,
                    backgroundColor: convertToRGBAString(rate_bg_color),
                  }}
                  className="flex-items-column centered pointer"
                >
                  <div
                    style={{
                      fontSize: 36.6,
                      width: 36.6,
                      height: 36.6,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color:
                        feedback.rate === option.name
                          ? convertToRGBAString(rate_selected_color)
                          : convertToRGBAString(rate_icon_color),
                    }}
                    // className="border"
                  >
                    {renderSmile(option.name)}
                  </div>
                  {show_rate_labels && (
                    <span
                      style={{
                        fontSize: 14,
                        marginTop: 6,
                        color:
                          feedback.rate === option.name
                            ? convertToRGBAString(rate_selected_color)
                            : convertToRGBAString(rate_icon_color),
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      className="font-helvetica-neue-medium"
                    >
                      {option.label[selectedLanguage]}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Form.Item>
    );
  }
);

export default ServiceRow;
